module.exports = __webpack_public_path__ + "img/welcome_image_left.7dd47310.svg";